<button class="relative h-6 w-8 cursor-pointer" [ngClass]="{ 'menu-open': isMenuOpen }">
  <i></i>
  <i></i>
  <i></i>
</button>
